import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { toast } from "react-toastify";
import { ProductCard } from "../../components";
import { Loader } from "../../components/Loader";
import { useFilter } from "../../context";
import { useTitle } from "../../hook/useTitle";
import { getProductList } from "../../services";
import { FilterBar } from "./components/FilterBar";

export const ProductList = () => {
  const {products, initialProductList } = useFilter();
  const [show, setShow] = useState(false);
  const search = useLocation().search
  const searchTerm = new URLSearchParams(search).get('q')


  useEffect(() => {
    async function fetchProducts() {
      try {
        const data = await getProductList(searchTerm)
        initialProductList(data)
      } catch(error) {
        toast.error(error.message, { closeButton: true, position: "bottom-center"});
      }
     
    }
    fetchProducts();
  }, [searchTerm]); //eslint-disable-line

  useTitle('Explore eBooks collection')
  
  return (
    <main>
      <section className="my-5">
        <div className="my-5 flex justify-between"> 
          <span className="text-2xl font-semibold dark:text-slate-100 mb-5">
            All eBooks ({products.length})
          </span>
          <span>
            <button
              id="dropdownMenuIconButton"
              data-dropdown-toggle="dropdownDots"
              className="inline-flex items-center p-2 text-sm font-medium text-center text-gray-900 bg-gray-100 rounded-lg hover:bg-gray-200 dark:text-white dark:bg-gray-600 dark:hover:bg-gray-700"
              type="button"
              onClick={() => setShow(!show)}
            >
              <svg
                className="w-6 h-6"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
              </svg>
            </button>
          </span>
        </div>

        <div className="flex flex-wrap justify-center lg:flex-row">
          {(products.length <= 0 || typeof products !== 'object') && <Loader />}
          {(typeof products === 'object' && products.length >= 0) && products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </section>
      {show && <FilterBar show={show} setShow={setShow} />}
    </main>
  );
};
